// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__7WdPp","lessons":"Navigation_lessons__ixrRR","user_guide":"Navigation_user_guide__WnTfd","about":"Navigation_about__rTJSY"};